import { c as _c } from "react/compiler-runtime";
import type { ReviewCreditCardsPage } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { Button } from '@mui/material';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { useAlternatePickClickAnalytics } from '../../hooks';
type AlternatePickReadReviewCtaProps = {
  ctaAnalytics: NonNullable<ReviewCreditCardsPage['alternatePicks'][number]['marketplaceEntity']>['ctaAnalytics'];
  reviewLink: string;
  parentActivityId: string;
};
export default function AlternatePickReadReviewCta(t0) {
  const $ = _c(6);
  const {
    ctaAnalytics,
    reviewLink,
    parentActivityId
  } = t0;
  const {
    fireClickPageAction
  } = useAlternatePickClickAnalytics("cta", parentActivityId);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button variant="outlined" sx={_temp}>{"Read our review"}</Button>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== ctaAnalytics || $[3] !== fireClickPageAction || $[4] !== reviewLink) {
    t3 = <CtaLink analytics={ctaAnalytics} href={reviewLink} parameterActions={t1} skipShoppingFinishedEvent={true} isReview={true} onClickAnalyticsCallback={fireClickPageAction}>{t2}</CtaLink>;
    $[2] = ctaAnalytics;
    $[3] = fireClickPageAction;
    $[4] = reviewLink;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(theme) {
  return {
    "&:hover": {
      boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main} !important`
    },
    letterSpacing: ".11rem",
    fontSize: ".875rem",
    lineHeight: ".9",
    width: "fit-content"
  };
}